import React, { Component } from 'react'
import { withRouter } from "react-router";
import logo from '../slider/images/logo.png'
import '../../home/index.css'
import DropDown from './dropdown'
import SearcBar from './search'

const odtufloraDropdown = [
    { name: "ODTÜ Kır Çiçekleri ve Bitki Örtüsü Hakkında", link: "bitki-ortusu-hakkinda" },
    { name: "ODTÜ Bitkileri Herbaryumu", link: "hebaryum" },
]

const nasilKullanilirDropdown = [
    { name: "Site hakkında", link: "hakkinda" },
    { name: "Adım adım türünü bul", link: "nasil-kullanilir" },
]

class NavBar extends Component {

    constructor(props) {
        super(props)
        this.state = {
            navClicked: false,
            items: [],
            showDropdown: false,
            offsetLeft: 0,
            onDropdown: false,
            openFor: ""
        }
        this.floraRef = React.createRef()
        this.nasilRef = React.createRef()
        this.openDropdown = this.openDropdown.bind(this)
        this.closeDropDown = this.closeDropDown.bind(this)
        this.onDropDown = this.onDropDown.bind(this)
        this.outDropDown = this.outDropDown.bind(this)
    }

    async openDropdown(items, ref) {
        await this.setState({ items, showDropdown: true, offsetLeft: ref.current.offsetLeft })
    }

    async openDropdownMobile(items, name) {
        await this.setState({ items, showDropdown: true, openFor: name })
    }

    async closeDropDown() {
        await this.setState({ showDropdown: false })
    }

    async onDropDown() {
        await this.setState({ onDropdown: true })
    }

    async outDropDown() {
        await this.setState({ onDropdown: false })
    }

    render() {
        return (
            <React.Fragment>
                <nav className="nav-bar-container">
                    <ul className="nav-bar-ul">
                        <li><a href="/">Anasayfa</a></li>
                        <li
                            ref={this.nasilRef}
                            onMouseEnter={() => this.openDropdown(nasilKullanilirDropdown, this.nasilRef)}
                            onMouseLeave={() => this.closeDropDown()}
                        >
                            <a href="/nasil-kullanilir">Nasıl Kullanılır</a>
                        </li>
                        <li
                            ref={this.floraRef}
                            onMouseEnter={() => this.openDropdown(odtufloraDropdown, this.floraRef)}
                            onMouseLeave={() => this.closeDropDown()}
                        >
                            <a href="/bitki-ortusu-hakkinda">ODTÜ Flora</a>
                        </li>
                        <li><a href="/kardes-projeler">Kardeş Projeler</a></li>
                        <li><a href="/bizkimiz">Biz Kimiz</a></li>
                        <li><a href="/select-plant" style={{ color: "#8dc640" }}>Çiçeğini bul</a></li>
                        <SearcBar openLeft={true} />
                    </ul>
                    {(this.state.showDropdown || this.state.onDropdown) &&
                        <DropDown position={"absolute"} items={this.state.items} offset={this.state.offsetLeft} onDropDown={this.onDropDown} outDropDown={this.outDropDown} />
                    }
                </nav>

                <nav className={"nav-bar-container-small nav-bar-container-small-clicked"}>
                    <div className="nav-bar-small-top">
                        <a href="https://dkm.org.tr"><img onClick={() => window.location = window.origin} className="nav-bar-logo" src={logo} alt={"dkm logo"} /></a>
                        <i onClick={async () => await this.setState({ navClicked: !this.state.navClicked })} className="fas fa-bars" style={{ fontSize: "22px"}}></i>
                    </div>
                </nav>

                {this.state.navClicked &&
                    <React.Fragment>
                        <ul className="nav-bar-ul-small">
                            <li><a href="/">Anasayfa</a></li>
                            <li
                                onClick={() => !this.state.showDropdown || this.state.openFor != "nasil" ? this.openDropdownMobile(nasilKullanilirDropdown, "nasil") : this.closeDropDown()}
                            >
                                <a>Nasıl Kullanılır</a>
                            </li>
                            {(this.state.showDropdown && this.state.openFor === "nasil") &&
                                <span style={{ marginLeft: 10 }}>
                                    <DropDown position={"initial"} items={this.state.items} offset={this.state.offsetLeft} onDropDown={this.onDropDown} outDropDown={this.outDropDown} />
                                </span>
                            }
                            <li
                                onClick={() => !this.state.showDropdown || this.state.openFor != "flora" ? this.openDropdownMobile(odtufloraDropdown, "flora") : this.closeDropDown()}
                            >
                                <a>ODTÜ Flora</a>
                            </li>
                            {(this.state.showDropdown && this.state.openFor === "flora") &&
                                <span style={{ marginLeft: 10 }}>
                                    <DropDown position={"initial"} items={this.state.items} offset={this.state.offsetLeft} onDropDown={this.onDropDown} outDropDown={this.outDropDown} />
                                </span>
                            }
                            <li><a>Kardeş Projeler</a></li>
                            <li><a>Duyurular</a></li>
                            <li><a>Biz Kimiz</a></li>
                            <li><a href="/select-plant" style={{ color: "#8dc640" }}>Çiçeğini bul</a></li>
                            <li><i className="fas fa-search"></i></li>

                        </ul>
                    </React.Fragment>
                }
                <a href="https://dkm.org.tr" className="dkm-logo-image" style={{float:"right"}}><img className="nav-bar-logo" src={logo} /></a>

            </React.Fragment>
        )
    }
}

export default withRouter(NavBar)
